$(function () {

    localStorage.clear();

    function base64ToBlob(base64, type = "application/octet-stream") {
        const binStr = atob(base64);
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
        }
        return new Blob([arr], { type: type });
    }

    $(document).on('click', '.search_offers', function (e) {
        e.preventDefault();
        var button = $(this);
        var form = $(this).closest("form");
        var form_data = form.serialize();
        console.log(form_data);
        var url = form.attr('action');
        button.html('<span class="spinner-border spinner-border-sm text-orange" role="status" aria-hidden="true"></span>');
        $.ajax({
            type: 'POST', url: url, data: form_data, async: true, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                    $('#search_results').html(data.content);
                } else {
                    console.log('Chyba');
                    $('#search_results').html(data.msg);
                }
            },
            error: function (data) {
                console.log(data);
                $('#search_results').html('Chyba - požadavku');
            },
            complete: function (data) {
                button.html('<i class="bi bi-search"></i>');
            },
        });
    });

    $(document).on('click', '.load_offers', function (e) {
        e.preventDefault();
        var button = $(this);
        $('#offersListModalLabel').html(button.data('business_case_name'));
        var url = button.data('url');
        url += '&scenario=configurator'
        console.log(url);
        button.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
        $.ajax({
            type: 'GET', url: url, async: true, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    //console.log(data);
                    $('#offersListModalBody').html(data.content);
                    $('#offersListModalLabel').html(button.data('business_case_name') + ' - počet nalezených nabídek: ' + data.count);
                } else {
                    console.log('chyba');
                    $('#offersListModalBody').html(data.msg);
                }
            },
            error: function (data) {
                console.log(data);
                $('#offersListModalBody').html('Chyba - požadavku');
            },
            complete: function (data) {
                button.html('<i class="bi bi-eye"></i>');
                $('#offersListModal').modal('show');
            },
        });
    });

    $(document).on('click', '.form_block_submit', function (e) {
        e.preventDefault();
        var filled = true;
        var form = $(this).closest('form');
        if (form.length === 0) {
            // header "Průběžně uložit" lives outside the <form>; target it explicitly
            form = $('form[data-offer_id]').first();
        }
        // "Průběžně uložit" saves the entered data without advancing the task,
        // so it skips the required-field validation of the current step.
        var only_save = $(this).hasClass('save_and_stay') ? '1' : '0';
        if (only_save == '0' && false == $('#ignore_requireds').prop('checked')) {
            $('[required]').each(function (i, el) {
                var displayed = $(el).closest('.item_envelope').css('display');
                if ($(el).prop('type') == 'file') {
                    let imgage_holder = $(el).data('image_holder');
                    let html = $('#' + imgage_holder).html();
                    if (displayed != 'none' && html.length < 10) {
                        $("[for='" + $(el).prop('id') + "']").css("background-color", "red");
                        filled = false;
                    }
                } else {
                    if (displayed != 'none' && ($(el).val() == '' || $(el).val() == undefined)) {
                        $(el).css("border-color", "red");
                        $(el).css("background-color", "#ffe6e6");
                        filled = false;
                    }
                }
            });
        }
        console.log($(this).data('to_block'));
        //return true;
        if (filled) {
            form.attr('action', form.attr('action') + '&block=' + $(this).data('to_block') + '&only_save=' + only_save);
            if ($('.items-log-area').exists()) {
                var el = $('.items-log-area');
                var val = el.val();
                var old_log = el.data('old_log');
                if (val.length == 0) {
                    var log = [{}];
                } else {
                    var log = JSON.parse(val);
                }
                el.val(JSON.stringify(old_log.concat(log)));
            }
            form.submit();
        } else {
            $("#error").html('<div class="alert alert-danger" role="alert">Nejsou vyplněny všechny povinné položky</div>');
            $("#error").show();
            setTimeout(function () {
                $("#error").hide();
            }, 2000);
        }
        return true;
    });

    $(document).on('click', '.form_block_add_and_submit', function (e) {
        e.preventDefault();
        var group_name = $(this).data('group_name');
        var counter = $('#' + $(this).data('counter_field'));
        var groups = $('div[id^="' + group_name + '_"][data-group_index]');
        if (groups.length === 0) { return false; }
        var last = groups.last();
        var newIndex = parseInt(last.data('group_index')) + 1;
        var clone = last.clone();
        clone.attr('id', group_name + '_' + newIndex);
        clone.attr('data-group_index', newIndex);
        clone.find('input, select, textarea').each(function () {
            var el = $(this);
            var name = el.attr('name');
            if (name) {
                el.attr('name', name.replace(
                    '[' + group_name + '][' + last.data('group_index') + ']',
                    '[' + group_name + '][' + newIndex + ']'
                ));
            }
            if (el.is(':checkbox') || el.is(':radio')) {
                // Ano/Ne toggles render as radios with static ids ({ident}_0 / {ident}_1) and a
                // <label for="..."> button. Cloning keeps those ids, so every group's label points
                // at group 0's input — clicking a switch in an added group flips the first group.
                // Give the cloned input a per-group id and repoint its label so each toggle is its own.
                var oldId = el.attr('id');
                if (oldId) {
                    var lbl = clone.find('label[for="' + oldId + '"]');
                    if (lbl.length) {
                        var newId = oldId.replace(/_g\d+$/, '') + '_g' + newIndex;
                        lbl.attr('for', newId);
                        el.attr('id', newId);
                    }
                }
                el.prop('checked', false);
            } else { el.val(''); }
        });
        last.after(clone);

        // Re-initialize signature pads inside the freshly added box. A cloned <canvas> carries no
        // SignaturePad instance (and duplicate ids from the original), so instantiate one per
        // inline_sign envelope and wire it to that box's own hidden value input — scoped to the
        // envelope, not global ids — otherwise the pad is inert on added rows.
        clone.find('canvas.signature-pad').each(function () {
            var canvas = this;
            var $env = $(canvas).closest('.item_envelope');
            var $value = $env.find('input[type="hidden"]').first();
            var $metaDate = $env.find('input[name*="_meta_date"]');
            var uid = group_name + '_' + newIndex + '_sig_' + $env.index();
            canvas.id = uid + '_pad';
            $value.attr('id', uid).val('');
            $env.find('[id$="_pad_clear"], button.btn-danger, button.btn-subtle-warning').attr('id', uid + '_pad_clear');
            var pad = new SignaturePad(canvas, { backgroundColor: 'rgb(255, 255, 255)', penColor: '#2d4c82' });
            pad.addEventListener('endStroke', function () {
                $value.val(pad.toDataURL('image/svg+xml'));
                var d = new Date($.now());
                var p = function (n) { return n < 10 ? '0' + n : '' + n; };
                $metaDate.val(d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' '
                    + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds()));
            });
            $('#' + uid + '_pad_clear').on('click', function (e) {
                e.preventDefault();
                pad.clear();
                $value.val('');
            });
        });

        counter.val(parseInt(counter.val()) + 1);
        return true;
    });

    jQuery.fn.exists = function () {
        return this.length > 0;
    };

    function solveLog(input_count) {
        if ($('.items-log-area').exists()) {
            var el = $('.items-log-area');
            var val = el.val();
            var old_log = el.data('old_log');
            if (val.length == 0) {
                var log = [{}];
            } else {
                var log = JSON.parse(val);
            }
            console.log(log);
            console.log(old_log);
            var found = false;
            log.forEach((log_item, index) => {
                if (log_item.code == input_count.data('product_code')) {
                    if (input_count.data('origin') == input_count.val()) {
                        log.splice(index, 1);
                        found = -1;
                    } else {
                        found = index;
                    }
                }
            });
            console.log(found);
            const date = new Date();
            let data_object = {
                'code': input_count.data('product_code'),
                'name': input_count.data('product_name'),
                'difference': (parseInt(input_count.val()) - parseInt(input_count.data('origin'))),
                'count_origin': parseInt(input_count.data('origin')),
                'count': parseInt(input_count.val()),
                'price': parseFloat(input_count.data('product_price')),
                'change_datetime': date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
            };
            if (found === false) {
                log.push(data_object);
            } else if (found === -1) {
                null;
            } else {
                log[found] = data_object;
            }
            el.val(JSON.stringify(log)).change();
            console.log(log);
        } else {
            return false;
        }
    }

    $(document).on('change', '.items-log-area', function (e) {
        console.log('clear_signs');
        $("*[id$='pad_clear']").click();
    });

    $(document).on('change', '.total_price_morework', function (e) {
        console.log('clear_signs');
        $("*[id$='pad_clear']").click();
    });

    $(document).on('click', '.mw_sum_plus', function (e) {
        e.preventDefault();
        var group = $(this).closest('.input-group');
        var input = group.find('input[type="number"]');
        input.val(parseInt(input.val()) + 1);
        solveLog(input);
        return true;
    });

    $(document).on('click', '.mw_sum_minus', function (e) {
        e.preventDefault();
        var group = $(this).closest('.input-group');
        var input = group.find('input[type="number"]');
        if (input.val() > 0) {
            input.val(parseInt(input.val()) - 1);
        }
        solveLog(input);
        return true;
    });

    $(document).on('click', '.form_block_remove', function (e) {
        e.preventDefault();
        var group_name = $(this).data('group_name');
        var counter = $('#' + $(this).data('counter_field'));
        var groups = $('div[id^="' + group_name + '_"][data-group_index]');
        if (groups.length <= 1) { return false; }
        groups.last().remove();
        counter.val(parseInt(counter.val()) - 1);
        return true;
    });

    $(document).on('change', '.master_field', function (e) {
        e.preventDefault();
        var new_val = $(this).val();
        var current_group_id = $(this).data('master_group_id');
        $("div[data-master_field='" + $(this).data('master_ident') + "']").each(function () {
            if (current_group_id === undefined || current_group_id == $(this).data('master_group_id')) {
                if (new_val == $(this).data('on_master_value')) {
                    $(this).css('display', '');
                } else {
                    $(this).css('display', 'none');
                }
            }
        });
        let text = $(this).data('master_ident');
        const myArray = text.split("_entrance_");
        $("div[data-master_field='" + myArray[0] + "']").each(function () {
            if (current_group_id === undefined || current_group_id == $(this).data('master_group_id')) {
                if (new_val == $(this).data('on_master_value')) {
                    $(this).css('display', '');
                } else {
                    $(this).css('display', 'none');
                }
            }
        });
    });

    $(document).on('click', '.show_note_field', function (e) {
        e.preventDefault();
        var element_ident = $(this).data('for_element');
        var note_element = $(document).find('[data-for="' + element_ident + '"]');
        if (note_element.length > 0) {
            note_element.css('display', 'block');
        }
    });

    $(document).on('click', '.remove_note_field', function (e) {
        e.preventDefault();
        var element_ident = $(this).data('for_element');
        var note_element = $(document).find('[data-for="' + element_ident + '"]');
        if (note_element.length > 0) {
            note_element.css('display', 'none');
            $('#' + element_ident + '_note').val('');
        }
    });

    $(document).on('click', '.remove_thumbnail', function (e) {
        e.preventDefault();
        if (!confirm('Opravdu odstranit fotografii?')) {
            return true;
        }
        var url = $(this).data('url');
        var thumbnail_id = $(this).data('thumbnail_id');
        var store_id = $(this).data('filestore');
        $.ajax({
            type: 'GET', url: url, async: true, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    $('#photo_thumbnail_' + thumbnail_id).remove();
                    store = $('#' + store_id).val();
                    var a_store = store.split(",");
                    var a_store = a_store.filter(function (elem) {
                        return elem != thumbnail_id;
                    });
                    $('#' + store_id).val(a_store.toString());
                } else {
                    console.log(data);
                }
            },
            error: function (data) {
                console.log(data);
            },
            complete: function (data) {
                null;
            },
        });
    });

    const dt = new DataTransfer();

    $(".image-upload-input").on('click', function (e) {
        var multiple = $(this).data('multiple');
        var file_input = $(this).attr('id');
        if (multiple == '0') {
            var store = $('#' + file_input + '_store').val();
            if (store) {
                var a_store = store.split(",");
                if (a_store.length > 0) {
                    e.preventDefault();
                    bootbox.alert('Lze nahrát pouze 1 soubor!');
                    return false;
                }
            }
        }
    });

    function showUploadOverlay() {
        if ($('#upload-overlay').length === 0) {
            $('body').append(
                '<div id="upload-overlay" style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.45);z-index:9999;display:flex;align-items:center;justify-content:center;">' +
                '<div class="text-center text-white">' +
                '<div class="spinner-border mb-2" role="status" style="width:3rem;height:3rem;"></div>' +
                '<div class="fw-bold fs-5">Nahrávám soubor...</div>' +
                '</div></div>'
            );
        }
    }

    function hideUploadOverlay() {
        $('#upload-overlay').remove();
    }

    $(".image-upload-input").on('change', function () {
        var imgPath = $(this)[0].value;
        var extn = imgPath.substring(imgPath.lastIndexOf('.') + 1).toLowerCase();
        var image_holder = $('#' + $(this).data('image_holder'));
        var upload_url = $(this).data('upload_url');
        var thumbnail_url = $(this).data('thumbnail_url');
        var offer_id = $(this).closest('form').data('offer_id');
        var remove_photo_url = $(this).closest('form').data('removephoto_url');
        var file_input = $(this).attr('id');
        if (extn == "gif" || extn == "png" || extn == "jpg" || extn == "jpeg") {
            if (typeof (FileReader) != "undefined") {
                var files = $(this).prop("files");
                for (var i = 0; i < files.length; i++) {
                    (function (file) {
                        if (file.type.indexOf("image") == 0) {
                            var fileReader = new FileReader();
                            fileReader.onload = function (f) {
                                $.ajax({
                                    type: "POST",
                                    url: upload_url,
                                    dataType: 'json',
                                    data: {
                                        'name': file.name,
                                        'size': file.size,
                                        'type': file.type,
                                        'creation_time': file.lastModifiedDate,
                                        'offer_id': offer_id,
                                        'file': f.target.result
                                    },
                                    beforeSend: function () {
                                        showUploadOverlay();
                                    },
                                    success: function (result) {
                                        let store = $('#' + file_input + '_store').val();
                                        if (store.length > 0) {
                                            store = store + ',';
                                        }
                                        store = store + result.data.file_ids[0];
                                        $('#' + file_input + '_store').val(store);
                                        var div = $("<div>", { "class": "col-6 col-sm-4 col-md-3 col-lg-2 photo_thumbnail", "id": "photo_thumbnail_" + result.data.file_ids[0] }).html($("<img />", { "src": f.target.result, "class": "img-thumbnail rounded float-start" }));
                                        div.append('<a href="#" data-name="' + file.name + '" data-id="' + i + '" data-filestore="' + file_input + '_store" data-thumbnail_id="' + result.data.file_ids[0] + '" class="btn btn-sm btn-danger remove_thumbnail" title="Odstranit foto" data-url="' + remove_photo_url + result.data.file_ids[0] + '"><i class="bi bi-trash"></i></a>');
                                        image_holder.append(div);
                                    },
                                    complete: function () {
                                        hideUploadOverlay();
                                    }
                                });

                            };

                            fileReader.readAsDataURL(file);
                        } else {
                            console.log('No image')
                        }
                    })(files[i]);
                }
            } else {
                bootbox.alert('Váš prohlížeč neumožňuje nahrát soubory.');
            }
        } else if ((extn == 'pdf') || (extn == 'doc') || (extn == 'odt') || (extn == 'docx')) {
            if (typeof FileReader != 'undefined') {
                var files = $(this).prop('files');
                for (var i = 0; i < files.length; i++) {
                    (function (file) {
                        var fileReader = new FileReader();
                        fileReader.onload = function (f) {
                            $.ajax({
                                type: 'POST',
                                url: upload_url,
                                dataType: 'json',
                                data: {
                                    name: file.name,
                                    size: file.size,
                                    type: file.type,
                                    creation_time: file.lastModifiedDate,
                                    offer_id: offer_id,
                                    file: f.target.result
                                },
                                beforeSend: function () {
                                    showUploadOverlay();
                                },
                                success: function (result) {
                                    var div = '';
                                    var files_thumbs = result.data.file_ids;
                                    $.each(files_thumbs, function (i, file_id) {
                                        $.ajax({
                                            type: 'POST',
                                            url:
                                                thumbnail_url +
                                                '?id=' +
                                                file_id,
                                            dataType: 'json',
                                            success: function (thumb_result) {
                                                if (
                                                    thumb_result.status ==
                                                    'success'
                                                ) {
                                                    $(
                                                        '#' +
                                                            file_input +
                                                            '_store'
                                                    ).val(store);
                                                    div = $('<div>', {
                                                        class: 'file-box-wrapper',
                                                        id:
                                                            'photo_thumbnail_' +
                                                            file_id
                                                    }).html(
                                                        '<div class="position-relative h-100"><div class="file-box overflow-hidden"><span class="fa-solid fa-file fs-3 text-body-tertiary"></span></div></div>'
                                                    );
                                                    div.append(
                                                        '<p class="d-block fw-bold text-body-highlight mt-2 text-nowrap text-truncate fs-9 fs-sm-8">' +
                                                            file.name +
                                                            '</p>'
                                                    );
                                                    div.append(
                                                        '<a href="#" data-name="' +
                                                            file.name +
                                                            '" data-id="' +
                                                            i +
                                                            '" data-filestore="' +
                                                            file_input +
                                                            '_store" data-thumbnail_id="' +
                                                            file_id +
                                                            '" class="btn btn-sm btn-danger position-absolute top-0 end-0 mt-1 me-1 remove_thumbnail" title="Odstranit soubor" data-url="' +
                                                            remove_photo_url +
                                                            file_id +
                                                            '"><i class="bi bi-trash"></i></a>'
                                                    );
                                                    image_holder.append(div);
                                                } else {
                                                    console.log(thumb_result);
                                                    bootbox.alert(
                                                        thumb_result.msg
                                                    );
                                                }
                                            }
                                        });
                                    });
                                    let store = $(
                                        '#' + file_input + '_store'
                                    ).val();
                                    if (store.length > 0) {
                                        store = store + ',';
                                    }
                                    store =
                                        store + result.data.file_ids.toString();
                                },
                                complete: function () {
                                    hideUploadOverlay();
                                }
                            });
                        };

                        fileReader.readAsDataURL(file);
                    })(files[i]);
                }
            } else {
                bootbox.alert('Váš prohlížeč neumožňuje nahrát soubory.');
            }
        } else {
            bootbox.alert('Prosím, nahrávejte pouze obrázky nebo PDF soubory');
        }
        $(this).val(null);
        return true;
    });

    $(document).on('click', '.show_thumbnail', function (e) {
        e.preventDefault();
        var photo_id = $(this).data('thumbnail_id');
        var data = $('#image_id_' + photo_id).attr('src');
        var downloadUrl = $('#image_id_' + photo_id).data('download_url');
        $('#photoModalContentPhoto').attr('src', data);
        if (downloadUrl && $('#photoModalContentPhotoDownload').length) {
            $('#photoModalContentPhotoDownload').attr('href', downloadUrl);
        }
        $('#photoModal').modal('show');
        return true;
    });

    $('.task-preview').on('click', function (e) {
        var title = $(this).data('title');
        var url = $(this).attr('href');
        console.log(url);
        $('#previewModalContent').html(
            '<div class="container">' +
                '<div class="placeholder-glow">' +
                '<h1 class="placeholder placeholder-lg col-6"></h1>' +
                    '<div class="placeholder col-10"></div>' +
                    '<div class="placeholder col-10"></div>' +
                    '<div class="placeholder col-10"></div>' +
                    '<div class="placeholder col-10"></div>' +
                '</div>' +
            '</div>');
        $('#previewModalLabel').html(title);
        $.ajax({
            type: 'GET', url: url, async: true, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    $('#previewModalContent').html(data.content);
                } else {
                    console.log(data);
                }
            },
            error: function (data) {
                console.log(data);
            },
            complete: function (data) {
                null;
            },
        });
    });

    $('.task-clean').on('click', function (e) {
        e.preventDefault();
        $('#cleanConfirmModalContent').html('Opravdu smazat hodnoty z vyplněného formuláře ' + $(this).data('title') + '?');
        $('#cleanConfirmModalRunButton').data('url', $(this).attr('href'));
        $('#cleanConfirmModal').modal('show');
        return true;
    });

    $('#cleanConfirmModalRunButton').on('click', function (e) {
        e.preventDefault();
        $('#cleanConfirmModal').modal('hide');
        var url = $(this).data('url');
        $.ajax({
            type: 'GET', url: url, async: true, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    $('#cleanResultModalContent').html('Obsah formuláře byl úspěsně odstraněn');
                    $('#cleanResultModal').modal('show');
                } else {
                    $('#cleanResultModalContent').html('Nepodařilo se smazat obsah formuláře');
                    $('#cleanResultModal').modal('show');
                    console.log(data);
                }
            },
            error: function (data) {
                $('#cleanResultModalContent').html('Nepodařilo se smazat obsah formuláře');
                $('#cleanResultModal').modal('show');
                console.log(data);
            },
            complete: function (data) {
                null;
            },
        });
    });

    $('#cleanResultModalButton').on('click', function (e) {
        e.preventDefault();
        window.location.reload();
    });

    $('.configurator-postprocess-run').on('click', function (e) {
        e.preventDefault();
        $(this).html('Spouštím automat');
        console.log('Starting postprocess');
        var url = $(this).data('webhook_url');
        var uuid = $(this).data('configurator_uuid');
        var button = $(this);
        $(this).prop("disabled", true);
        $(this).html('Automat pro zpracování byl spuštěn');
        $.ajax({
            type: 'POST',
            url: url,
            async: true,
            contentType: "application/json; charset=UTF-8",
            dataType: 'json',
            data: JSON.stringify({ 'uuid': uuid }),
            success: function (data) {
                console.log(data);
                console.log('Process OK');
            },
            error: function (data) {
                console.log(data);
                console.log('Process start failed');
                //button.html('Chyba - nepodařilo se spustit automat');
                //$('#automatRunModalContent').html('Chyba při spuštění automatu.');
            },
            complete: function (data) {
                console.log('Make scenario run completly');
                button.html('V pořádku - automat byl spuštěn');
                window.location.reload();
            },
        });
        console.log(data);
        console.log('Process OK');
    });

    $('.reload_page_button').on('click', function (e) {
        window.location.reload();
        var url = $(this).data('redirect_url');
        document.location = url;
    });

    $('.previewPdf').on('click', function (e) {
        e.preventDefault();
        $('#pdf_loader').css('display', 'block');
        $('#pdf-container').html('');
        var pdfid = $(this).data('pdfid');
        var url = $(this).data('apiurl');
        $.ajax({
            type: 'GET',
            url: url + '&id=' + pdfid,
            async: true,
            contentType: "application/json; charset=UTF-8",
            dataType: 'json',
            success: function (data) {
                console.log('Download OK');
                console.log(data.fileinfo);
                var base64 = data.resultdata;
                const blob = base64ToBlob(base64, 'application/pdf');
                const url = URL.createObjectURL(blob);
                var pdfData = atob(data.resultdata);
                var arr = new Uint8Array(pdfData.length);
                for (var i = 0; i < pdfData.length; i++) {
                    arr[i] = pdfData.charCodeAt(i);
                }
                var pdfDoc = null;

                pdfjsLib.getDocument(arr).promise.then(function (pdfDoc_) {
                    pdfDoc = pdfDoc_;
                    var pageCount = pdfDoc.numPages;
                    var idCan = 1
                    for (var pageNum = 1; pageNum <= pageCount; ++pageNum) {
                        pdfDoc.getPage(pageNum).then(function (page) {
                            var canvas = document.createElement('canvas');
                            canvas.setAttribute("id", idCan);
                            //canvas.setAttribute("class", "pdf-preview-page");
                            idCan++;
                            var viewport = page.getViewport({
                                scale: 1.5
                            });
                            canvas.height = viewport.height;
                            canvas.width = viewport.width;
                            var renderContext = {
                                canvasContext: canvas.getContext('2d'),
                                viewport: viewport
                            };
                            page.render(renderContext);

                            var pdfContainer = document.getElementById('pdf-container');
                            pdfContainer.appendChild(canvas);
                        });
                    }
                });

                $('#pdf_download_btn').empty();
                $('#pdf_download_btn').append('<a href="data:' + data.fileinfo.contentType + ';base64,' + btoa(pdfData) + '" download="' + data.fileinfo.fileName + '" class="btn btn-subtle-primary w-100"><i class="bi bi-download me-2"></i>Stáhnout</a>');
                //$('#pdf_download_btn').attr('href', 'data:'+data.fileinfo.contentType+';base64,'+btoa(pdfData));
                //$('#pdf_download_btn').attr('download', data.fileinfo.fileName);
            },
            error: function (data) {
                console.log('Load failed');
                console.log(data);
                $('#pdfModalContent').html('Chyba stažení souboru!');
            },
            complete: function (data) {
                $('#pdf_loader').css('display', 'none');
                console.log('Completed');
            },
        });
    });

    // SIGNATURE SECTION
    var canvas = document.getElementById('signature-pad');
    var canvas2 = document.getElementById('signature-pad_2');

    if (canvas2 !== null) {
        var signaturePad2 = new SignaturePad(canvas2, {
            backgroundColor: 'rgb(255, 255, 255)'
        });
        var output_element2 = $('#signature_hash_2');

        if (output_element2.val().length > 0) {
            signaturePad2.fromDataURL(output_element2.val());
        }
    }

    if (canvas !== null) {
        var signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)'
        });
        var output_element = $('#signature_hash');

        if (output_element.val().length > 0) {
            signaturePad.fromDataURL(output_element.val());
        }

        //document.getElementById('store_signature').addEventListener('click', function (e) {
        $('#store_signature').on('click', function (e) {
            e.preventDefault();
            if (signaturePad.isEmpty()) {
                bootbox.alert({
                    message: 'Musíte vložit podpis klienta.',
                    backdrop: true,
                    buttons: { ok: { label: 'OK', className: 'btn-danger' } }
                });
                return false;
            }
            if (canvas2 !== null && signaturePad2.isEmpty()) {
                bootbox.alert({
                    message: 'Musíte vložit podpis klienta 2.',
                    backdrop: true,
                    buttons: { ok: { label: 'OK', className: 'btn-danger' } }
                });
                return false;
            }

            var data = signaturePad.toDataURL("image/svg+xml");
            console.log(data);
            $('#signature_hash').val(data);

            if (canvas2 !== null) {
                var data2 = signaturePad2.toDataURL("image/svg+xml");
                $('#signature_hash_2').val(data2);
            }

            var form = $(this).closest("form");
            console.log(form.attr('action'));
            form.attr('action', form.attr('action') + '&block=' + $(this).data('to_block'));
            console.log(form.attr('action'));
            form.submit();
        });

        $('#clear').on('click', function (e) {
            e.preventDefault();
            signaturePad.clear();
            $('#signature_hash').val('');
        });

        $('#clear_2').on('click', function (e) {
            e.preventDefault();
            signaturePad2.clear();
            $('#signature_hash_2').val('');
        });
    }
    // END OF SIGNATURE SECTION

    $(document).on('click', '#show_montage_notes', function (e) {
        e.preventDefault();
        $('#montage_notes').toggle();
    });

    $(document).on('click', '#montage_notes_close', function (e) {
        e.preventDefault();
        $('#montage_notes').toggle();
    });

    $(document).on('click', "a[data-task_ident='sign']", function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var el_envelope = $(this).closest('.row').closest('.row');
        el_envelope = el_envelope.parent('div').parent('div');
        var el_icon = el_envelope.find('i');
        if (el_icon.hasClass('bi-check2-circle')) {
            bootbox.confirm({
                message: 'Podpis již byl vyplněn. Pokračováním dojde k jeho odstranění. Chcete pokračovat?',
                buttons: {
                    confirm: {
                        label: 'Ano',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Ne',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        document.location = url;
                        return true;
                    }
                }
            });
        } else {
            document.location = url;
        }
    });

    $(document).on('click', "a[data-task_ident!='sign']", function (e) {
        if ($(this).data('button_type') == 'enter_task') {
            e.preventDefault();
            var url = $(this).attr('href');
            var el_envelope = $(this).closest('.row').closest('.row');
            el_envelope = el_envelope.parent('div').parent('div');
            var el_icon = el_envelope.find('i');
            if (el_icon.hasClass('bi-check2-circle')) {
                bootbox.confirm({
                    message: 'Formulář již byl vyplněn. Pokud budete pokračovat je nutné kliknout ve formuláři na tlačítko DOKONČIT',
                    buttons: {
                        confirm: {
                            label: 'Souhlasím',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'Ne',
                            className: 'btn-danger'
                        }
                    },
                    callback: function (result) {
                        if (result) {
                            document.location = url;
                            return true;
                        }
                    }
                });
            } else {
                document.location = url;
            }
        } else {
            return true;
        }
    });

    $(document).on('click', '.add_to_partlist_out', function (e) {
        e.preventDefault();
        var list_select = $('#' + $(this).data('list_id'));
        var out_div = $('#' + $(this).data('list_id') + '_partlist_out');
        if (list_select.val().length > 0) {
            out_div.append('<div class="input-group"><input type="text" name="FormField[' + $(this).data('list_id') + '][]" value="' + list_select.val() + ' | ' + $('#' + $(this).data('list_id') + ' option:selected').text() + '" class="form-control form-control-sm">'
                + '<span class="input-group-btn"><button type="button" class="remove_item_from_partlist btn btn-small bg-danger text-white"><i class="bi bi-trash"></i></button></span>'
                + '</div>');
        }
        console.log(list_select.val());
        return true;
    });

    $(document).on('click', '.remove_item_from_partlist', function (e) {
        e.preventDefault();
        var envelope = $(this).closest('.input-group').remove();
        return true;
    });

    $(document).on('click', '.add_to_stock_out', function (e) {
        e.preventDefault();
        var list_select = $('#' + $(this).data('list_id'));
        var out_div = $('#' + $(this).data('list_id') + '_stock_out');
        if (list_select.val().length > 0) {
            out_div.append('<div class="input-group"><input type="text" name="FormField[' + $(this).data('list_id') + '][]" value="1ks | ' + list_select.val() + ' | ' + $('#' + $(this).data('list_id') + ' option:selected').text() + '" class="form-control form-control-sm">'
                + '<span class="input-group-btn"><button type="button" class="remove_item_from_stocklist btn btn-small bg-danger text-white" data-list_id="' + $(this).data('list_id') + '"><i class="bi bi-trash"></i></button></span>'
                + '</div>');
        }
        console.log(list_select.val());
        return true;
    });

    $(document).on('click', '.remove_item_from_stocklist', function (e) {
        e.preventDefault();
        var id_item = $(this).data('list_id');
        var envelope = $(this).closest('.input-group').parent('div');
        $(this).closest('.input-group').remove();
        if (envelope.children('div').length == 0) {
            envelope.append(
                '<input type="hidden" id="fake_item" name="FormField[' + id_item + '_items][item_id][]" value="" readonly="readonly" class=""></input>'
                + '<input type="hidden" id="fake_item" name="FormField[' + id_item + '_items][code][]" value="" readonly="readonly" class=""></input>'
                + '<input type="hidden" id="fake_item" name="FormField[' + id_item + '_items][name][]" value="" readonly="readonly" class=""></input>'
                + '<input type="hidden" id="fake_item" name="FormField[' + id_item + '_items][count][]" value="" readonly="readonly" class=""></input>'
                + '<input type="hidden" id="fake_item" name="FormField[' + id_item + '_items][unit][]" value="" readonly="readonly" class=""></input>'
                + '<input type="hidden" id="fake_item" name="FormField[' + id_item + '_items][price][]" value="" readonly="readonly" class=""></input>'
            );
        }
        return true;
    });

    $(document).on('click', '.add_to_moreworks', function (e) {
        e.preventDefault();
        var list_select = $('#' + $(this).data('list_id'));
        var out_div = $('#' + $(this).data('list_id') + '_stock_out');
        var item_detail = null;
        if (out_div.children('div').length == 0) {
            out_div.html('');
        }
        if (list_select.val().length == 0) {
            bootbox.alert('Vyberte položku z ceníku')
            return true;
        }
        var url = list_select.data('item_detail_url') + '&item_id=' + list_select.val();
        $.ajax({
            type: 'GET', url: url, async: false, dataType: 'json', global: false,
            success: function (data) {
                if (data.status == 'success') {
                    item_detail = data.data;
                } else {
                    bootbox.alert('Chyba načítání dat: ' + data.msg);
                }
            },
            error: function (data) {
                bootbox.alert('Chyba načítání dat');
                console.log(data);
            }
        });

        if (list_select.val().length > 0) {
            out_div.append('<div class="input-group">'
                + '<input type="hidden" name="FormField[' + $(this).data('list_id') + '_items][item_id][]" value="' + item_detail.id + '" readonly="readonly" class="pricelist_morework_item_item_id">'
                + '<input type="hidden" name="FormField[' + $(this).data('list_id') + '_items][code][]" value="' + item_detail.item_code + '" readonly="readonly" class="pricelist_morework_item_item_code">'
                + '<input type="text" name="FormField[' + $(this).data('list_id') + '_items][name][]" value="' + item_detail.item_name + '" readonly="readonly" class="form-control form-control-sm pricelist_morework_item_name">'
                + '<input type="number" name="FormField[' + $(this).data('list_id') + '_items][count][]" value="1" class="form-control form-control-sm pricelist_morework_item_count">'
                + '<input type="text" name="FormField[' + $(this).data('list_id') + '_items][unit][]" value="' + item_detail.unit + '" readonly="readonly" class="form-control form-control-sm pricelist_morework_item_unit">'
                + '<input type="number" name="FormField[' + $(this).data('list_id') + '_items][price][]" value="' + item_detail.price + '" readonly="readonly" class="form-control form-control-sm pricelist_morework_item_price">'
                + '<span class="input-group-btn"><button type="button" class="remove_item_from_stocklist btn btn-small bg-danger text-white"><i class="bi bi-trash"></i></button></span>'
                + '</div>');
        }

        var out_div = $('#' + $(this).data('list_id') + '_stock_out');
        var total_price = 0
        $('.pricelist_morework_item_count').each(function (i) {
            var count = $(this).val();
            var price = $(this).closest('.input-group').find('.pricelist_morework_item_price').val();
            console.log(count, ' x ', price);
            total_price += count * price;
        });

        console.log(total_price);
        $('.total_price_morework').val(total_price).change();

        return true;
    });

    $(document).on('change', '.pricelist_morework_item_count', function (e) {
        var total_price = 0
        $('.pricelist_morework_item_count').each(function (i) {
            var count = $(this).val();
            var price = $(this).closest('.input-group').find('.pricelist_morework_item_price').val();
            total_price += count * price;
        });
        $('.total_price_morework').val(total_price).change();
    });

    $(document).on('change', '.pricelist_morework_item_price', function (e) {
        var total_price = 0
        $('.pricelist_morework_item_count').each(function (i) {
            var count = $(this).val();
            var price = $(this).closest('.input-group').find('.pricelist_morework_item_price').val();
            total_price += count * price;
        });
        $('.total_price_morework').val(total_price).change();
    });

    $(document).on('click', '.remove_item_from_stocklist', function (e) {
        e.preventDefault();
        var envelope = $(this).closest('.input-group').remove();
        var total_price = 0
        $('.pricelist_morework_item_count').each(function (i) {
            var count = $(this).val();
            var price = $(this).closest('.input-group').find('.pricelist_morework_item_price').val();
            total_price += count * price;
        });
        $('.total_price_morework').val(total_price).change();
        return true;
    });

    $(document).on('change', '.sign_type_switcher', function (e) {
        var ident = $(this).data('ident');
        if ($(this).is(':checked')) {
            $('#' + ident + '_pad_remote').removeClass('hidden');
            $('#' + ident + '_pad_on_site').addClass('hidden');
        } else {
            $('#' + ident + '_pad_remote').addClass('hidden');
            $('#' + ident + '_pad_on_site').removeClass('hidden');
        }
        return true;
    });

    $(document).on('click', '.init_use_businesscase', function (e) {
        e.preventDefault();
        var button = $(this);
        var url = button.data('url_get_detail');
        console.log(url);
        button.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
        $.ajax({
            type: 'GET', url: url, async: true, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                    $('#businesscaseform-id').val(data.data.id);
                    $('#businesscaseform-company_id').val(data.data.company.id);
                    $('#businesscaseform-name').val(data.data.name);
                    $('#businesscaseform-businesscase_type').val(data.data.businessCaseType.id).change();
                    $('#businesscaseform-businesscase_state').val(data.data.businessCasePhase.id);
                    if (data.data.category == null) {
                        $('#businesscaseform-product_type').val(null);
                    } else {
                        $('#businesscaseform-product_type').val(data.data.category.id);
                    }
                    let el_summernote = '#businesscaseform-description';
                    $(el_summernote).summernote({
                        blockquoteBreakingLevel: 1,
                        height: 200,
                        toolbar: [
                            ['style', ['bold', 'italic', 'underline']]
                        ]
                    });
                    $(el_summernote).summernote('code', data.data.description);
                } else {
                    console.log('chyba');
                    $('#BusinessCaseDetailsModal').html(data.msg);
                }
            },
            error: function (data) {
                console.log(data);
                $('#BusinessCaseDetailsModal').html('Chyba - požadavku');
            },
            complete: function (data) {
                button.html('Vybrat');
                $('#BusinessCaseDetailsModal').modal('show');
            },
        });
    });

    $(document).on('click', '.init_new_businesscase', function (e) {
        e.preventDefault();
        $('#businesscaseform-id').val(null);
        $('#businesscaseform-company_id').val($(this).data('company_id'));
        $('#businesscaseform-name').val($(this).data('company_name'));
        $('#businesscaseform-businesscase_type').val('');
        $('#businesscaseform-businesscase_state').val('');
        $('#businesscaseform-product_type').val('');
        let el_summernote = '#businesscaseform-description';
        $(el_summernote).summernote({
            blockquoteBreakingLevel: 1,
            height: 200,
            toolbar: [
                ['style', ['bold', 'italic', 'underline']]
            ]
        });
        $(el_summernote).summernote('code', '');
        $('#BusinessCaseDetailsModal').modal('show');
    });

    $(document).on('change', '#businesscaseform-businesscase_type', function (e) {
        e.preventDefault();
        var bc_type = $(this).val();
        var target = $('#businesscaseform-businesscase_state');
        var url = target.data('items_url') + '&type=' + bc_type;
        $.ajax({
            type: 'GET', url: url, async: true, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                    target.empty();
                    $.each(data.data, function (k, v) { target.append('<option value="' + k + '">' + v + '</option>'); });
                } else {
                    console.log('chyba');
                    alert(data.msg);
                }
            },
            error: function (data) {
                console.log(data);
                alert('Chyba - požadavku');
            }
        });
    });

    $(document).on('change', '.entrance_counter', function (e) {
        var old_value = parseInt($(this).data('current_value'));
        var new_value = parseInt($(this).val());
        var current_count = $('.envelope_identifier').length;
        if (old_value < new_value) {
            number_add = new_value - current_count;
            for (let i = current_count + 1; i <= new_value; i++) {
                $('.entrances_envelope').append(
                    '<div class="col-12 mt-3 mb-3 entrance_' + i + '_envelope envelope_identifier">'
                    + '<label for="bd_pocet_vchodu_entrance_' + i + '">Adresa vchod ' + i + '</label>'
                    + '<input type="text" id="bd_pocet_vchodu_entrance_' + i + '" class="form-control" name="FormField[bd_pocet_vchodu_entrance_' + i + ']" value="" maxlength="255" required>'
                    + '</div>'
                );
            }
        }
        if (old_value > new_value) {
            number_add = new_value - current_count;
            for (let i = current_count; i > new_value; i--) {
                $('.entrance_' + i + '_envelope').remove();
            }
        }
        $(this).data('current_value', new_value);
    });

    $(document).on('click', '.same_as_entrance_field', function (e) {
        e.preventDefault();
        var for_ident = $(this).data('for_ident');
        var master_val = $('#' + for_ident).val();
        let this_id = $(this).attr('id');
        let main_id = this_id.replace(/_entrance_[0-9]*/g, "");
        main_id = main_id.replace(/_sameas/g, "");
        $('input[id^="' + main_id + '"]').each(function (el) {
            $('#' + $(this).attr('id')).val(master_val);
        });
        return true;
    });

    /*
    $(document).on('change', '.same_as_entrance_field', function (e) {
        e.preventDefault();
        var same_as = $(this).val();
        var for_ident = $(this).data('for_ident');
        if (same_as.length < 1) {
            $('#' + for_ident).attr('readonly', false);
            $('#' + for_ident).removeClass('disabled');
            $('#' + for_ident).val('');
            return true;
        }
        let same_as_arr = same_as.split("_");
        let for_ident_arr = for_ident.split("_");
        let same_as_id = same_as_arr[same_as_arr.length - 1];
        let for_ident_id = for_ident_arr[for_ident_arr.length - 1];
        if (same_as_id == for_ident_id) {
            alert('Nelze nastavit stejný vchod');
            $(this).val(null).change();
            $('#' + for_ident).attr('readonly', false);
            $('#' + for_ident).removeClass('disabled');
            $('#' + for_ident).val('');
            return true;
        } else {
            $('#' + for_ident).attr('readonly', true);
            $('#' + for_ident).addClass('disabled');
            $('#' + for_ident).attr('required', false);
            let str = for_ident.replace("_" + for_ident_id, "") + '_' + same_as_id;
            $('#' + for_ident).val($('#' + str).val());
        }
        return true;
    });

    $(document).on('change', '.update_same_as_fields', function (e) {
        e.preventDefault();
        let this_id = $(this).attr('id');
        let main_id = this_id.replace(/_entrance_[0-9]*\/g, "");
        $('.same_as_entrance_field').each(function (el) {
            let current = $(this).attr('id');
            let test = main_id + '_entrance_';
            if (current.indexOf(test) >= 0) {
                var same_as = $(this).val();
                if (same_as.length > 0) {
                    var for_ident = $(this).data('for_ident');
                    let same_as_arr = same_as.split("_");
                    let same_as_id = same_as_arr[same_as_arr.length - 1];
                    $('#' + for_ident).val($('#' + main_id + '_entrance_' + same_as_id).val());
                }
            }
        });
    });
    */

    function setAmountsOnPercentages() {
        var proc_1 = parseInt($('#sml_2_proc_1_platba').val());
        var proc_2 = parseInt($('#sml_2_proc_2_platba').val());
        var proc_3 = parseInt($('#sml_2_proc_3_platba').val());
        var total_amount = parseFloat($('#sml_2_celkova_cena').val());
        var typ = $('#sml_2_typ_platby_vyber').val();
        var payments = $('#sml_2_pocet_plateb').val();
        if (typ.length < 3) {
            return true;
        }
        const payments_scenarios_2 = ["2_platby_dotace", "2_platby_sop", "2_platby_sop_dotace", "2_platby_bez_dotace", "2_platby_montaz"];
        const payments_scenarios_3 = ["3_platby_dotace", "3_platby_sop", "3_platby_sop_dotace", "3_platby_bez_dotace", "3_platby_montaz"];
        if (payments_scenarios_2.includes(typ, 0) && payments != '2_platby') {
            $('p[for="sml_2_proc_err_mess"]').html('<span style="color:red;">Musíte vybrat 2 platby pro tento scénář</span>');
            return true;
        } else if (payments_scenarios_3.includes(typ, 0) && payments != '3_platby') {
            $('p[for="sml_2_proc_err_mess"]').html('<span style="color:red;">Musíte vybrat 3 platby pro tento scénář</span>');
            return true;
        } else {
            $('p[for="sml_2_proc_err_mess"]').html('');
        }
        if (payments == '2_platby' && (proc_1 + proc_2 != 100)) {
            $('p[for="sml_2_proc_err_mess"]').html('<span style="color:red;">Součet % musí být 100. Nelze vypočítat ceny!</span>');
            return true;
        } else if (payments == '3_platby' && (proc_1 + proc_2 + proc_3 != 100)) {
            $('p[for="sml_2_proc_err_mess"]').html('<span style="color:red;">Součet % musí být 100. Nelze vypočítat ceny!</span>');
            return true;
        } else {
            $('p[for="sml_2_proc_err_mess"]').html('');
        }
        if (payments == '2_platby') {
            var payment_1 = (total_amount / 100 * proc_1).toFixed(0);
            var payment_2 = (total_amount / 100 * proc_2).toFixed(0);
        }
        if (payments == '3_platby') {
            var payment_1 = (total_amount / 100 * proc_1).toFixed(0);
            var payment_2 = (total_amount / 100 * proc_2).toFixed(0);
            var payment_3 = (total_amount / 100 * proc_3).toFixed(0);
        }
        switch (typ) {
            case '2_platby_dotace':
                $('#sml_2_HTML_Platba_1_castka').val(payment_1);
                break;
            case '3_platby_dotace':
                $('#sml_2_HTML_Platba_2_castka').val(payment_1);
                $('#sml_2_HTML_Platba_2_castka_2').val(payment_2);
                break;
            case '2_platby_sop':
                $('#sml_2_HTML_Platba_3_castka').val(payment_1);
                break;
            case '3_platby_sop':
                $('#sml_2_HTML_Platba_4_castka').val(payment_1);
                $('#sml_2_HTML_Platba_4_castka_2').val(payment_2);
                break;
            case '3_platby_sop_dotace':
                $('#sml_2_HTML_Platba_6_castka').val(payment_1);
                $('#sml_2_HTML_Platba_6_castka_2').val(payment_2);
                break;
            case '3_platby_bez_dotace':
                $('#sml_2_HTML_Platba_8_castka').val(payment_1);
                $('#sml_2_HTML_Platba_8_castka_2').val(payment_2);
                break;
            case '2_platby_montaz':
                $('#sml_2_HTML_Platba_9_castka').val(payment_1);
                break;
            case '3_platby_montaz':
                $('#sml_2_HTML_Platba_10_castka').val(payment_1);
                $('#sml_2_HTML_Platba_10_castka_2').val(payment_2);
                break;
        }

    }

    $(document).on('change', '#sml_2_typ_platby_vyber', function () {
        var this_val = $(this).val();
        if (this_val.startsWith('2_') && $('#sml_2_pocet_plateb').val() != '2_platby') {
            $('#sml_2_pocet_plateb').val('2_platby').change();
        }
        if (this_val.startsWith('3_') && $('#sml_2_pocet_plateb').val() != '3_platby') {
            $('#sml_2_pocet_plateb').val('3_platby').change();
        }
        setAmountsOnPercentages();
    });

    $(document).on('change', '#sml_2_pocet_plateb', function () {
        if ($(this).val() == '2_platby') {
            $('#sml_2_proc_1_platba').val(60);
            $('#sml_2_proc_2_platba').val(40);
            $('#sml_2_proc_3_platba').val(0);
        } else if ($(this).val() == '3_platby') {
            $('#sml_2_proc_1_platba').val(30);
            $('#sml_2_proc_2_platba').val(30);
            $('#sml_2_proc_3_platba').val(40);
        }
        setAmountsOnPercentages();
    });

    $(document).on('change', '#sml_2_proc_1_platba', function () { setAmountsOnPercentages(); });
    $(document).on('change', '#sml_2_proc_2_platba', function () { setAmountsOnPercentages(); });
    $(document).on('change', '#sml_2_proc_3_platba', function () { setAmountsOnPercentages(); });

    /**
     * QR Code reader logic
    */

    let html5QrCode;
    const readerId = "reader";
    let currentScanTargetInputId = null;

    const config = {
        fps: 10,
        qrbox: { width: 300, height: 250 },
        aspectRatio: 1.0,
        formatsToSupport: [
            Html5QrcodeSupportedFormats.QR_CODE,
            Html5QrcodeSupportedFormats.CODABAR,
            Html5QrcodeSupportedFormats.EAN_13,
            Html5QrcodeSupportedFormats.EAN_8,
            Html5QrcodeSupportedFormats.UPC_A,
            Html5QrcodeSupportedFormats.UPC_E,
            Html5QrcodeSupportedFormats.CODE_128,
            Html5QrcodeSupportedFormats.CODE_39,

        ]
    };

    // Event listener for all scan buttons
    $(document).on('click', '.scan-button', function() {
        currentScanTargetInputId = $(this).closest('.input-group').find('.form-control');
    });

    // Handle modal shown event to start the scanner
    $('#scannerModal').on('shown.bs.modal', function () {
        startScanning();
    });

    // Handle modal hidden event to stop the scanner
    $('#scannerModal').on('hidden.bs.modal', function () {
        stopScanning();
    });

    function startScanning() {
        if (!html5QrCode) {
            html5QrCode = new Html5Qrcode(readerId);
        }

        const cameraConfig = { facingMode: "environment" };

        html5QrCode.start(
            cameraConfig,
            config,
            (decodedText, decodedResult) => {
                console.log("Code scanned: " + decodedText);

                if (currentScanTargetInputId) {
                    $('#' + currentScanTargetInputId).val(decodedText);
                }

                stopScanning();
                $('#scannerModal').modal('hide');
            },
            (errorMessage) => {
                null;
            }
        ).catch((err) => {
            bootbox.alert("Nepodařilo se spustit kameru: " + err);
            $('#scannerModal').modal('hide');
        });
    }

    function stopScanning() {
        if (html5QrCode && html5QrCode.isScanning) {
            html5QrCode.stop().then((ignore) => {
                // Scanning is stopped, now clear
                html5QrCode.clear();
            }).catch((err) => {
                console.log("Failed to stop or clear: " + err);
            });
        } else if (html5QrCode) {
            html5QrCode.clear();
        }
    }


});
